import React from 'react';
import {
  Cushion,
  FlexContainer,
  Rectangle,
  ShimmerAvatar,
  ShimmerTypography,
} from '@pitchero/react-ui';

const SelectionLoadingState = () => (
  <Rectangle>
    <Cushion all="small">
      <FlexContainer flexDirection="row" justifyContent="space-between" alignItems="center">
        <ShimmerAvatar size={48} />
        <Cushion horizontal="medium" style={{ flex: 1 }}>
          <ShimmerTypography preset="subtitle--small" width="40%" />
          <ShimmerTypography preset="body--small" width="30%" />
        </Cushion>
      </FlexContainer>
    </Cushion>
  </Rectangle>
);

export default SelectionLoadingState;
